import {ModelDate} from '../../shared/DTO/modelDate';
import {ProductState} from '../../shared/DTO/productState';
import {IdentityModel} from './identity.model';
import {ProductTypeModel} from './product-type.model';
import {BaseModel} from '../../base/models/base-model.model';
import {BasicProperty1Model} from "./basic-property1.model";

export class BasicProductModel extends BaseModel {
  private _activationDate?: ModelDate;
  private _certifiedEmail?: string;
  private _description?: string;
  private _duration?: string;
  private _expirationDate?: ModelDate;
  private _identity?: IdentityModel;
  private _productType?: ProductTypeModel;
  private _state?: ProductState;
  private _unitId?: string;
  private _userId?: string;
  private _properties?: Array<BasicProperty1Model>;

  constructor(activationDate?: ModelDate, certifiedEmail?: string, description?: string, duration?: string, expirationDate?: ModelDate, identity?: IdentityModel, productType?: ProductTypeModel, state?: ProductState, unitId?: string, userId?: string, properties?: Array<BasicProperty1Model>) {
    super();
    this._activationDate = activationDate;
    this._certifiedEmail = certifiedEmail;
    this._description = description;
    this._duration = duration;
    this._expirationDate = expirationDate;
    this._identity = identity;
    this._productType = productType;
    this._state = state;
    this._unitId = unitId;
    this._userId = userId;
    this._properties = properties;
  }

  get properties(): Array<BasicProperty1Model> {
    return this._properties;
  }

  set properties(value: Array<BasicProperty1Model>) {
    this._properties = value;
  }

  get userId(): string {
    return this._userId;
  }

  set userId(value: string) {
    this._userId = value;
  }

  get activationDate(): ModelDate {
    return this._activationDate;
  }

  set activationDate(value: ModelDate) {
    this._activationDate = value;
  }

  get certifiedEmail(): string {
    return this._certifiedEmail;
  }

  set certifiedEmail(value: string) {
    this._certifiedEmail = value;
  }

  get description(): string {
    return this._description;
  }

  set description(value: string) {
    this._description = value;
  }

  get duration(): string {
    return this._duration;
  }

  set duration(value: string) {
    this._duration = value;
  }

  get expirationDate(): ModelDate {
    return this._expirationDate;
  }

  set expirationDate(value: ModelDate) {
    this._expirationDate = value;
  }

  get identity(): IdentityModel {
    return this._identity;
  }

  set identity(value: IdentityModel) {
    this._identity = value;
  }

  get productType(): ProductTypeModel {
    return this._productType;
  }

  set productType(value: ProductTypeModel) {
    this._productType = value;
  }

  get state(): ProductState {
    return this._state;
  }

  set state(value: ProductState) {
    this._state = value;
  }

  get unitId(): string {
    return this._unitId;
  }

  set unitId(value: string) {
    this._unitId = value;
  }

}
